// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__objKi","action":"style_action__A0YbZ","action_btn":"style_action_btn__npSfA"};